import {
  HubConnectionBuilder,
  HubConnection,
} from '@microsoft/signalr'
import { useQuery } from 'react-query'
import { useEffect } from 'react'

export type RecivedMethodType<TData> = {
  onRecived?: (data: TData) => void
  name: string
}
type ReciveMethod = {
  methods: Array<RecivedMethodType<any>>
  dependencies?: Array<any>
}
type SocketType = {
  controllerName: string
  ReciveMethods?: ReciveMethod
  token?: string,
  onError?: (err: any) => void
}
export type SocketInvoke = {
  Invoke?: (method: string, param?: any) => Promise<any>
  stop?: () => Promise<void>
}
type _methodType = {
  key: string
  method: (data: any) => void
}
var listMethod: Array<_methodType> = []

function useSocket(option: SocketType): SocketInvoke {
  const fetch = useQuery<HubConnection>(
    [option.controllerName, option.token],
    async () => {
      const hub = new HubConnectionBuilder()
        .withUrl(
          `${window.env['APP_Domain']}/${option.controllerName}`,
          {
            accessTokenFactory: () => option.token ?? "",
          }
        )
        .withAutomaticReconnect()
        .build()
      await hub.start()
      return hub
    },
    {
      enabled: false,
      retry: false,
      staleTime: 0,
      cacheTime: 0,
      onError(err) {
        option.onError?.(err);
      },
    }
  )
  try {
    useEffect(() => {
      const load = async () => {
        const { data } = await fetch.refetch()
      }
      fetch.data?.stop()
      if (fetch.isError) {
        setTimeout(() => {
          load()
        }, 300);
      }
      else
        load()
    }, [option.token])
  } catch (error) { }
  useEffect(() => {
    option.ReciveMethods?.methods.forEach((m) => {
      const _methodIndex = listMethod.findIndex((n) => n.key === m.name)
      if (_methodIndex !== -1) {
        listMethod[_methodIndex].method = (data) => m.onRecived?.(data)
      } else {
        listMethod.push({
          key: m.name,
          method: (data) => {
            m.onRecived?.(data)
          },
        })
      }
    })
  }, [option.ReciveMethods?.dependencies])
  useEffect(() => {
    if (fetch.data) {
      option.ReciveMethods?.methods.forEach((element) => {
        fetch.data!.on(element.name, (d) => {
          listMethod.find((n) => n.key === element.name)?.method(d)
        })
      })
    }

  }, [fetch.data])

  return {
    Invoke(method, param) {
      return new Promise<any>((res, rej) => {
        const send = async () => {
          try {
            if (param) return fetch.data?.invoke(method, param)
            else return fetch.data?.invoke(method)

          }
          catch (ex) {
            option.onError?.(ex)
            rej(ex)
          }
        }
        send().then((result) => res(result)).catch((ex) => rej(ex))
      })
    },
    stop: fetch.data?.stop
  }
}

export default useSocket
